import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const RouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return RouterPush.call(this, to).catch(err => err)
}
const RouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (to) {
  return RouterReplace.call(this, to).catch(err => err)
}

const routes = [
  {
    path: '/login',
    name: '帆扬宇亿科技-舆情监测系统',
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/',
    name: '舆情搜索-帆扬宇亿科技-舆情监测系统',
    component: () => import('../views/homePage/index.vue')
  },
  {
    path: '/mobile/publicOpinionSearch',
    name: '搜索详情页-帆扬宇亿科技-舆情监测系统',
    component: () => import('../views/publicOpinionSearch/mobile_publicOpinionSearch.vue')
  },
  {
    path: '/publicOpinionSearch',
    name: '搜索详情页-帆扬宇亿科技-舆情监测系统',
    component: () => import('../views/publicOpinionSearch/publicOpinionSearch.vue')
  },
  {
    path: '/mySubscription',
    name: '专项监测-帆扬宇亿科技-舆情监测系统',
    component: () => import('../views/mySubscription/index.vue')
  },
  {
    path: '/myDownload',
    name: '我的下载-帆扬宇亿科技-舆情监测系统',
    component: () => import('../views/myDownload/index.vue')
  },
  // {
  //   path: '/darenMonitor',
  //   name: '达人监测',
  //   component: () => import('../views/darenMonitor/index.vue')
  // },
  // {
  //   path: '/darenDetails',
  //   name: '达人监测详情',
  //   component: () => import('../views/darenDetails/index.vue')
  // },
  // {
  //   path: '/earlyWarn',
  //   name: '预警管理',
  //   component: () => import('../views/earlyWarn/earlyWarn.vue')
  // },
  {
    path: '/brandPublicOpinion',
    name: '专项分析-帆扬宇亿科技-舆情监测系统',
    component: () => import('../views/brandPublicOpinion/brandPublicOpinion.vue')
  },
  { 
    path: '/pointsDetails',
    name: '积分管理-帆扬宇亿科技-舆情监测系统',
    component: () => import('../views/pointsDetails/pointsDetails.vue')
  },
  {
    path: '/deductionExplanation',
    name: '积分扣减说明-帆扬宇亿科技-舆情监测系统',
    component: () => import('../views/deductionExplanation/deductionExplanation.vue')
  },
  {
    path: '/personalData',
    name: '个人资料-帆扬宇亿科技-舆情监测系统',
    component: () => import('../views/personalData/personalData.vue')
  },
]

const router = new VueRouter({
  routes
})
router.beforeEach(function (to, from, next) {
  if (to.name) {
    document.title = to.name
  }
  next()
})

export default router
